





























import Vue from "vue";
import { isQaEnvironment } from "@/utils/qaEnvironment/qaEnvironment";

type SkinOption = { skin: number; label: string };

// Skins with a theme file in src/assets/themes. Names follow Core's client branding list
// where it has one.
const SKIN_OPTIONS: SkinOption[] = [
  { skin: 0, label: "0 / base" },
  { skin: 1, label: "1 / blue" },
  { skin: 2, label: "2 / green" },
  { skin: 3, label: "3 / gold" },
  { skin: 4, label: "4 / red" },
  { skin: 5, label: "5 / grey" },
  { skin: 6, label: "6 / purple" },
  { skin: 7, label: "7 / Vodafone" },
  { skin: 8, label: "8 / BOI" },
  { skin: 9, label: "9 / DAA" },
  { skin: 10, label: "10 / Laya EAP" },
  { skin: 11, label: "11 / Incorporate Benefits" },
  { skin: 12, label: "12 / Run in the dark" },
  { skin: 13, label: "13 / SanusX" },
  { skin: 14, label: "14 / Microsoft" },
  { skin: 15, label: "15 / L&W" },
  { skin: 16, label: "16 / BOI no logos" },
  { skin: 17, label: "17 / Ornua" },
  { skin: 18, label: "18 / Simply Health" },
  { skin: 19, label: "19 / PWC" },
  { skin: 20, label: "20 / Benenden Health" },
  { skin: 21, label: "21 / Irish Distillers" },
  { skin: 22, label: "22 / Pfizer" },
  { skin: 23, label: "23 / Radox" },
  { skin: 24, label: "24 / EY" },
  { skin: 25, label: "25 / L&G" },
  { skin: 26, label: "26 / WPA" },
  { skin: 27, label: "27 / HCML" },
  { skin: 28, label: "28 / EY" },
  { skin: 29, label: "29 / Bupa" },
  { skin: 30, label: "30 / Hospitality Action" },
  { skin: 32, label: "32 / Intel" },
  { skin: 33, label: "33" },
  { skin: 34, label: "34" },
  { skin: 35, label: "35 / Grocery Aid" },
  { skin: 36, label: "36 / L&G Purple" },
];

export default Vue.extend({
  name: "SideNavThemeSelect",
  computed: {
    isShown(): boolean {
      return isQaEnvironment() && this.$store.getters.showThemeSelectInNav;
    },
    isDarkMode(): boolean {
      return this.$store.getters.darkMode;
    },
    skin(): number {
      return this.$store.getters.skin;
    },
    skinOptions(): SkinOption[] {
      return SKIN_OPTIONS;
    },
  },
  methods: {
    selectSkin(skin: number): void {
      this.$store.commit("setSkin", skin);
    },
  },
});
